import { StyleSheet, Text, View } from "react-native";

import type { UiTheme } from "../theme";
import { hiddenFromScreenReader } from "./hiddenFromScreenReader";

// The box at the left of a selectable row: an empty ring, or a tinted ring
// with a ✓. The SHAPE says it, never the colour alone. Drawn only: the row
// that holds it carries the role and the checked/selected state, so a screen
// reader hears the row once. Born in the exercise picker's multi-select
// (its "select dot"), shared with the program editor's selection (#336).
export function SelectMark({ theme, checked }: { theme: UiTheme; checked: boolean }) {
  const styles = makeStyles(theme);
  return (
    <View style={[styles.box, checked && styles.boxOn]} {...hiddenFromScreenReader()}>
      {checked ? <Text style={styles.check}>✓</Text> : null}
    </View>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, typography: t } = theme;
  return StyleSheet.create({
    box: {
      width: 28,
      height: 28,
      borderRadius: 14,
      borderWidth: 2,
      borderColor: p.border,
      alignItems: "center",
      justifyContent: "center",
    },
    // Selection = brand100 tint + brand outline (not a full brand fill), per
    // the selection-cue convention. Colour budget S3.4.
    boxOn: { backgroundColor: p.brand100, borderColor: p.brand500 },
    check: { color: p.brand500, fontSize: t.sizes.sm, fontWeight: "900" },
  });
}
